import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { installOverlayClickGuard } from './utils/overlayClickGuard';
import { installFleetSoundUnlock } from './utils/fleetSound';
import { installFleetWebPushLogoutCleanup } from './services/webPush.service';

// Input'ta metin seçerken mouse overlay üzerinde bırakılınca modal kapanmasın.
installOverlayClickGuard();

// Service worker kaydı artık burada değil: tek kayıt noktası webPush.service.js'teki
// setupFleetWebPush() (bkz. o dosyadaki yorum — iki register() çağrısının aynı scope'ta
// farklı sorgu diziyle yarışması belirsiz güncelleme semantiğine yol açıyordu).

/* Web push token'ı HER çıkış yolunda düşsün: elle çıkış App.jsx'te ele alınıyor ama
   oturum süresi dolduğunda (auth.service refresh catch'i / api.service 401 interceptor'ı)
   yalnız 'auth:logout' olayı yayılıyordu. Dinleyici burada kurulur çünkü auth.service
   webPush.service'i import edemez (webPush → api → auth zinciri döngüye girerdi). */
installFleetWebPushLogoutCleanup();

// Bildirim sesi: tarayıcı otomatik-oynatma kilidi ilk kullanıcı etkileşiminde açılır.
installFleetSoundUnlock();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
